import { AppModel } from '../../../modules/Apps';

import { TargetsTableBody } from './TargetsTableBody';
import { TargetsTableEmptyState } from './TargetsTableEmptyState';
import { TargetsTableErrorState } from './TargetsTableErrorState';
import { TargetsTableLoadingState } from './TargetsTableLoadingState';

interface TargetsTableContentProps {
  app?: AppModel;
  isLoading: boolean;
  isError: boolean;
}

export function TargetsTableContent({ app, isLoading, isError }: TargetsTableContentProps) {
  if (isLoading) {
    return <TargetsTableLoadingState />;
  }

  if (isError) {
    return <TargetsTableErrorState />;
  }

  if (!app) {
    return <TargetsTableErrorState message="Invalid App" />;
  }

  if (!app?.targets?.length) {
    return <TargetsTableEmptyState />;
  }

  return <TargetsTableBody app={app} />;
}
